/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Language } from './language';
import {
    LanguageFromJSON,
    LanguageFromJSONTyped,
    LanguageToJSON,
    LanguageToJSONTyped,
} from './language';

/**
 * 
 * @export
 * @interface UserPreferencePostRequest1
 */
export interface UserPreferencePostRequest1 {
    /**
     * Unique identifier for the preferred conversation type.
     * @type {string}
     * @memberof UserPreferencePostRequest1
     */
    preferredConversationTypeId?: string | null;
    /**
     * Unique identifier for the language. Possible values: en, de
     * @type {Language}
     * @memberof UserPreferencePostRequest1
     */
    preferredLanguage?: Language | null;
}



/**
 * Check if a given object implements the UserPreferencePostRequest1 interface.
 */
export function instanceOfUserPreferencePostRequest1(value: object): value is UserPreferencePostRequest1 {
    return true;
}

export function UserPreferencePostRequest1FromJSON(json: any): UserPreferencePostRequest1 {
    return UserPreferencePostRequest1FromJSONTyped(json, false);
}

export function UserPreferencePostRequest1FromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPreferencePostRequest1 {
    if (json == null) {
        return json;
    }
    return {
        
        'preferredConversationTypeId': json['preferred_conversation_type_id'] == null ? undefined : json['preferred_conversation_type_id'],
        'preferredLanguage': json['preferred_language'] == null ? undefined : LanguageFromJSON(json['preferred_language']),
    };
}

export function UserPreferencePostRequest1ToJSON(json: any): UserPreferencePostRequest1 {
    return UserPreferencePostRequest1ToJSONTyped(json, false);
}

export function UserPreferencePostRequest1ToJSONTyped(value?: UserPreferencePostRequest1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'preferred_conversation_type_id': value['preferredConversationTypeId'],
        'preferred_language': LanguageToJSON(value['preferredLanguage']),
    };
}

